var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1654 7.08464C14.1654 4.78345 12.2999 2.91797 9.9987 2.91797C7.69751 2.91797 5.83203 4.78345 5.83203 7.08464C5.83203 9.3858 7.69751 11.2513 9.9987 11.2513C12.2999 11.2513 14.1654 9.3858 14.1654 7.08464Z",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8346 17.0833C15.8346 13.8617 13.223 11.25 10.0013 11.25C6.77964 11.25 4.16797 13.8617 4.16797 17.0833",
    stroke: "#1E201C",
    strokeWidth: 1.25,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.2006fefbd6ae9c27b97d52d58049adfd.svg";
export { ForwardRef as ReactComponent };